export default __webpack_public_path__ + "static/media/deezer-sqr.12bd058b.svg";